<template>
    <div class="teamlead-progress-table">
        <el-table :data="items" :row-key="getRowKey" stripe class="domain-table"
            :show-overflow-tooltip="false" table-layout="fixed" max-height="600">
            <template slot="empty">
                <div v-if="loading" class="loading-body">
                    <i class="el-icon-loading"></i>
                    <span>Đang tải...</span>
                </div>
                <div v-else class="empty-body">
                    <span>Không có dữ liệu</span>
                </div>
            </template>
            <el-table-column label="Thời gian" width="110">
                <template slot-scope="{ row }">
                    <span>Quý {{convertToRoman(row.quarter)}}/{{row.year}}</span>
                </template>
            </el-table-column>
            <el-table-column label="Họ tên" width="200">
                <template slot-scope="{ row }">
                    <span>{{row.user.name}}</span>
                </template>
            </el-table-column>
            <el-table-column label="Mã NS" width="80">
                <template slot-scope="{ row }">
                    <span>{{row.user?.id + 100000 ?? ''}}</span>
                </template>
            </el-table-column>

            <el-table-column label="Chức vụ" width="140">
                <template slot-scope="{ row }">
                    <span>{{row.user?.profile?.account_type?.name}}</span>
                </template>
            </el-table-column>
            <el-table-column label="Team" width="140">
                <template slot-scope="{ row }">
                    <span>{{row.department?.name}}</span>
                </template>
            </el-table-column>
            <el-table-column label="Số EXP" width="100">
                <template slot-scope="{row}">
                    {{ row.exp_points ?? 0 }}
                </template>
            </el-table-column>
            <el-table-column label="Điểm KRA" width="110">
                <template slot-scope="{ row }">
                    <span class="link">{{ parseInt(row.kra_score) ? parseInt(row.kra_score) + '/100' : '0/100'}}</span>
                </template>
            </el-table-column>

            <el-table-column label="Tổng điểm" width="120">
                <template slot-scope="{ row }">
                    <el-tooltip content="Giải thích: Tổng điểm / điểm cần đạt để tăng level" placement="top" effect="light">
                        <span style="color: #4D1EAB; font-weight: 600;">{{ calcTotal(row) }}/ {{ row.requested_level.score }}</span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="Kết quả" width="120">
                <template slot-scope="{ row }">
                    <span :class="getApproveType(row.approve_type_management).type">{{ getApproveType(row.approve_type_management).label }}</span>
                </template>
            </el-table-column>
            <el-table-column :min-width="600">
                <template slot="header">
                    <div class="level-scale">
                        <span>Trainee</span>
                        <span>Junior 1</span>
                        <span>Junior 2</span>
                        <span>Member 1</span>
                        <span>Member 2</span>
                        <span>Senior 1</span>
                        <span>Senior 2</span>
                    </div>
                </template>
                <template slot-scope="{row}">
                    <div class="track">
                        <el-tooltip effect="light" placement="right" content="Level quản trị">
                            <div class="bar admin" :style="barWidth(overallWidth(row.current_level.level))"
                            :data-label="currentLabel(row, 'admin')"></div>
                        </el-tooltip>
                        <el-tooltip effect="light" placement="right" content="Level chuyên môn">
                            <div class="bar domain" :style="barWidth(overallWidth(row.management_level_name))"
                            :data-label="currentLabel(row, 'domain')"></div>
                        </el-tooltip>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="Hành động" width="120">
                <template slot-scope="{ row }">
                    <button class="btn btn-info btn-sm btn-icon waves-effect waves-themed" title="Xem tiêu chí" @click="openModal(row)">
                        <i class="fa fa-eye" v-if="currentUser.id != row.user_id"></i>
                        <i class="el-icon-edit" v-else></i>
                    </button>
                </template>
            </el-table-column>
        </el-table>
    </div>

</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: 'TeamleadProgressTable',
    props: {
        items: { type: Array, default: () => [] },
        loading: { type: Boolean, default: false },
    },
    computed: {
        ...mapGetters(['currentUser']),
    },
    data() {
        return {
            approve_type: {
                1: { type: 'success',  label: 'Lên level' },
                2: { type: 'info', label: 'Xuống level' },
                3: { type: 'primary', label: 'Giữ nguyên level' },
            },
        };
    },
    methods: {
        convertToRoman(num) {
            const romanNumerals = {
                1: 'I',
                2: 'II', 
                3: 'III',
                4: 'IV'
            };
            return romanNumerals[num] || num;
        },
        getRowKey(row) {
            return row.id || row.employeeId || `${row.fullName}-${row.periodLabel}`;
        },
        barWidth(percent) {
            const p = Math.max(0, Math.min(100, Number(percent || 0)));
            return { width: p + '%' };
        },
        overallWidth(bands) {
            const order = ['trainee', 'junior1', 'junior2', 'member1', 'member2', 'senior1', 'senior2'];

            if (typeof bands === 'string') {
                const normalized = bands.toLowerCase().trim();
                const level = normalized.match(/(senior|junior|member|trainee)/)?.[1];
                const number = normalized.match(/[12]/)?.[0];

                const normalizedBands = level === 'trainee' ? 'trainee' : `${level}${number || '2'}`;
                const idx = Math.max(0, order.indexOf(normalizedBands));
                return ((idx + 0.5) / order.length) * 100;
            }

            const totalPercent = order.reduce((sum, key) => {
                const val = Math.max(0, Math.min(100, Number(bands?.[key] ?? 0)));
                return sum + val;
            }, 0);

            return Math.max(0, Math.min(100, (totalPercent / 700) * 100));
        },
        currentLabel(row, track) {
            const key = track === 'admin' ? row.current_level.level : row.management_level_name;
            return key;
        },
        calcTotal(row){
            const n = v => (parseInt(v) || 0);
            const kraScore = n(row?.kra_score);
            const meetingPoints = n(row?.meeting_points);
            const expPoints = n(row?.exp_points);
            const totalMinusPoint = n(row?.total_minus_point);
            const sum = kraScore + meetingPoints + expPoints - totalMinusPoint;
            return Math.max(0, sum);
        },
        openModal(row) {
            this.$emit('userIdOpentModal', {
                userId: row.user_id,
                year: row.year,
                quarter: row.quarter,
                userName: row.user?.name ?? '',
            });
        },
        getApproveType(approve_type) {
            return this.approve_type[approve_type] || '';
        }
    }
};
</script>

<style lang="scss" scoped>
.track {
    position: relative;
    height: 48px;
}

.track .bar {
    height: 24px;
    border-radius: 12px;
    position: absolute;
    left: 0;
    transition: width .3s ease;
    /* animation only; keep existing visuals */
    transform-origin: left center;
    transform: scaleX(0);
    animation: fill-grow 1.8s ease-in-out forwards;
}


.track .bar::after {
  content: attr(data-label);
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  color: white;
  padding: 2px 6px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

 .track .bar.admin {
     background: linear-gradient(90deg, #6d28d9 0%, #a78bfa 100%);
 }

 .track .bar.domain {
     background: linear-gradient(90deg, #22d3ee 0%, #3b82f6 100%);
 }

.track .bar.domain {
    top: 28px;
}


::v-deep {
    .domain-table {
        .el-table__header th,
        .el-table__body td,
        .el-table__header th .cell,
        .el-table__body td .cell {
            white-space: normal !important;
            word-break: keep-all !important;
            overflow: visible !important;
            max-width: none !important;
            height: auto !important;
            text-align: center !important;
        }

        .el-table__header th {
            background: #4d1eab !important;
            color: #fff !important;
            border-color: #4d1eab !important;
            line-height: 1.4 !important;
            padding: 16px 8px !important;
            height: 80px !important;
        }

        .el-table__body td {
            line-height: 1.3 !important;
            padding: 8px 4px !important;
            height: auto !important;
        }

        .el-table__body tr {
            height: 80px !important;
        }
    }
}

.level-scale {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    align-items: end;
    gap: 0;
}

.level-scale span {
    text-align: center;
    font-weight: 600;
}

.loading-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    color: #606266;
    
    i {
        font-size: 24px;
        margin-bottom: 10px;
        animation: rotating 2s linear infinite;
    }
    
    span {
        font-size: 14px;
    }
}

.empty-body {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    color: #909399;
    
    span {
        font-size: 14px;
    }
}

@keyframes rotating {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

@keyframes fill-grow {
  0% { transform: scaleX(0); }
  100% { transform: scaleX(1); }
}
</style>